import * as React from 'react'
import { TranslationContext } from 'helpers/withTranslations'

export const useTranslation = () => {
  const { t, locale, translations } = React.useContext(TranslationContext)

  return { t, locale, translations }
}
